import { useState } from "react";

const testimonials = [
  {
    id: 1,
    author: "Sarah & Mike Thompson",
    location: "Scottsdale, AZ",
    rating: 5,
    comment: "We completely transformed our backyard with ARAVELLA furniture. The teak quality is absolutely stunning and everything has held up perfectly through two Arizona summers. Our patio is now our favorite room in the house!",
    product: "Teak Adirondack Chair + Wicker Sectional",
    avatar: "https://public.readdy.ai/ai/img_res/4bf410fa0db1e6823cf76cecc5994969.jpg",
    image: "https://readdy.ai/api/search-image?query=beautiful%20outdoor%20patio%20with%20teak%20furniture%20and%20wicker%20sectional%20sofa%2C%20lush%20garden%20background%2C%20warm%20evening%20light%2C%20Arizona%20backyard%20lifestyle%20photography&width=500&height=400&seq=testimg001&orientation=landscape",
  },
  {
    id: 2,
    author: "Jennifer Rodriguez",
    location: "Paradise Valley, AZ",
    rating: 5,
    comment: "The outdoor daybed with canopy is absolutely incredible. It feels like having a five-star resort in our backyard. The quality is exceptional and the customer service from ARAVELLA was outstanding.",
    product: "Outdoor Daybed with Canopy",
    avatar: "https://readdy.ai/api/search-image?query=woman%20portrait%20headshot%20elegant%20smile%20outdoor%20warm%20light&width=80&height=80&seq=test002&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=luxury%20outdoor%20daybed%20with%20canopy%20poolside%20beautiful%20backyard%2C%20resort%20style%20patio%2C%20warm%20sunlight%2C%20Arizona%20luxury%20home%20lifestyle%20photography&width=500&height=400&seq=testimg002&orientation=landscape",
  },
  {
    id: 3,
    author: "Robert & Linda Chen",
    location: "Phoenix, AZ",
    rating: 5,
    comment: "We ordered the 6-piece dining set and it arrived in perfect condition. The teak table is gorgeous and the wicker chairs are so comfortable. Our outdoor dinner parties have never been better!",
    product: "Outdoor Dining Set 6-Piece",
    avatar: "https://readdy.ai/api/search-image?query=asian%20couple%20portrait%20outdoor%20smiling%20natural%20light&width=80&height=80&seq=test003&orientation=squarish",
    image: "https://readdy.ai/api/search-image?query=outdoor%20dining%20table%20set%20with%20family%20dinner%20party%20patio%20setting%2C%20teak%20table%20wicker%20chairs%2C%20warm%20evening%20light%2C%20garden%20background%2C%20lifestyle%20photography&width=500&height=400&seq=testimg003&orientation=landscape",
  },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-[#4A7C2F] text-sm font-medium tracking-widest uppercase">What Customers Say</span>
          <h2 className="text-4xl font-bold text-[#1a1a1a] mt-2" style={{ fontFamily: "'Playfair Display', serif" }}>
            Real Stories, Real Spaces
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
          {/* Image */}
          <div className="lg:col-span-2">
            <div className="w-full h-[360px] rounded-3xl overflow-hidden">
              <img
                src={t.image}
                alt={t.author}
                className="w-full h-full object-cover object-top transition-all duration-500"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <span className="text-gray-300 text-xs tracking-widest uppercase mb-4 block">(Customer Review)</span>
            <div className="flex items-center gap-1 mb-5">
              {[1,2,3,4,5].map(s => (
                <i key={s} className="ri-star-fill text-amber-400 text-lg"></i>
              ))}
            </div>
            <blockquote className="text-[#1a1a1a] text-xl leading-relaxed mb-6 font-light" style={{ fontFamily: "'Playfair Display', serif" }}>
              &ldquo;{t.comment}&rdquo;
            </blockquote>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <img src={t.avatar} alt={t.author} className="w-full h-full object-cover" />
              </div>
              <div>
                <div className="font-semibold text-[#1a1a1a] text-sm">{t.author}</div>
                <div className="text-gray-400 text-xs">{t.location} &bull; {t.product}</div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex items-center gap-3">
              <button
                onClick={() => setCurrent((current - 1 + testimonials.length) % testimonials.length)}
                className="w-11 h-11 flex items-center justify-center rounded-full border border-gray-200 hover:border-gray-400 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line text-gray-500"></i>
              </button>
              <button
                onClick={() => setCurrent((current + 1) % testimonials.length)}
                className="w-11 h-11 flex items-center justify-center rounded-full bg-[#2D5016] text-white hover:bg-[#3d6826] transition-colors cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <span className="text-gray-400 text-sm ml-2">{current + 1} / {testimonials.length}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
